module.exports = __webpack_public_path__ + "static/icon-532fedff7331ac9cd170f00a01838284.jpg";